<script>
export default {
  name: 'SlideNavigation',

  props: {
    items: {
      type: Array,
    },

    currentItemId: {
      type: String,
    },
  },

  data() {
    return {
      width: null,
      left: null,
      resizeObserver: null,
    };
  },

  computed: {
    lineStyle() {
      return `width: ${this.width}px; position: absolute; left: ${this.left}px;`;
    },
  },

  methods: {
    setData() {
      this.width = this.$refs[this.currentItemId][0].offsetWidth;
      this.left = this.$refs[this.currentItemId][0].offsetLeft;
    },

    setDataWithDelay() {
      setTimeout(() => {
        this.setData();
      }, 100);
    },
  },

  mounted() {
    this.resizeObserver = new ResizeObserver(() => this.setDataWithDelay());
    this.resizeObserver.observe(this.$refs.wrapper);
  },

  beforeUnmount() {
    this.resizeObserver.disconnect();
  },

  watch: {
    currentItemId() {
      this.setData();
    },
  },
};
</script>

<template>
  <nav class="navigation">
    <div class="wrapper" ref="wrapper">
      <button
        class="button"
        v-for="item in items"
        :ref="item.id"
        :class="{ active: item.id === currentItemId }"
        :key="item.id"
        @click="$emit('onClick', item.id)"
      >
        {{ item.label }}
      </button>

      <div class="line" v-if="width" :style="lineStyle" />
    </div>
  </nav>
</template>

<style lang="scss" scoped>
.navigation {
  margin-top: $space-32;
  border-bottom: 1px solid $separator-color;
  overflow: scroll;
  // Hide scrollbars
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  .wrapper {
    display: inline-flex;
    position: relative;
  }

  .button {
    @include headline-medium;
    white-space: nowrap;
    background: none;
    color: $text-color-secondary;
    border: 0;
    padding: 0 0 $space-8;
    margin: 0; // Needed for Safari
    margin-right: 20px;
    transition: $transition;

    &:last-of-type {
      margin-right: 0;
    }

    &:hover,
    &.active {
      color: $text-color-primary;
    }
  }

  .line {
    height: 3px;
    bottom: 0;
    border-radius: $border-radius-x-small;
    background: $interaction-color-primary;
    transition: all $transition;
  }
}
</style>
